import React from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'
import JobOfferCard from '../JobOfferCard'
import ctaBackgroundImage from 'images/job_offers/banners/cta_background.png'
import friendSmallImage from 'images/job_offers/banners/friend_small.png'
import remoteImage from 'images/job_offers/banners/remote.png'
import bnrKisoImage from 'images/job_offers/banners/bnr_kiso.png'
import dxBoostImage from 'images/job_offers/banners/dx_boost.png'
import { job_offers_remotes_path, knowledge_path, referral_path, signup_user_path } from '../../../../routes'
import { appTheme } from '../../../config/styled'
import { UserJobOffer } from '../../../../javascripts/api/generated'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import MemberTechCompanyName  from '../MemberTechCompanyName'
import Session from 'javascripts/layouts/v2/Session'


export type JobOffersContainerProps = {
  jobOffers: Array<{ detail: UserJobOffer, isFavorite: boolean, isApplied: boolean }>,
  loggedOut: boolean,
  session: Session
}

const JobOffersContainerStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
`

const JobOffersContainerRowStyle = styled.div`
  display: contents;
`

const JobBannerCtaStyle = styled.div`
  --tw-border-opacity: 1;
  --tw-gradient-from: #fff;
  --tw-gradient-stops: var(--tw-gradient-from), #fff, var(--tw-gradient-to, rgba(255, 255, 255, 0));
  --tw-gradient-to: #E7FAEC;
  display: flex;
  align-items: start;
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  border-width: 1px;
  border-style: solid;
  border-color: rgba(192, 196, 206, var(--tw-border-opacity));
  color: #222;
  flex-direction: column;
  padding: 1px;

  p {
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
    margin: 1.5rem 0 0.25rem 0;
    width: 100%;

    a {
      --tw-bg-opacity: 1;
      --tw-text-opacity: 1;
      display: block;
      background-color: rgba(224, 49, 0, var(--tw-bg-opacity));
      border-radius: 9999px;
      box-sizing: content-box;
      color: rgba(255, 255, 255, var(--tw-text-opacity));
      font-size: 1.25rem;
      font-weight: 400;
      line-height: 1;
      text-decoration: none;
      margin: 1.5rem auto 0 auto;
      padding: 1rem 0 1rem 0;
      width: 16rem;
      height: 1.25rem;
    }
  }

  img {
    width: 100%;
  }

  @media ${props => props.theme.media.sm} {
    background-image: linear-gradient(to right, var(--tw-gradient-stops));
    flex-direction: row;
    padding: 0 2rem 0 2rem;

    p {
      font-size: 1.25rem;
      font-weight: 700;
      margin: 2rem 0 2rem 0;
      width: 50%;
    }

    img {
      margin-left: 1.5rem;
      width: 50%;
    }
  }
`

const JobOffersBannersStyle = styled.div`
  width: 100%;
  margin-bottom: 1.25rem;

  .slick-list {
    margin-right: -0.75rem;
  }

  .slick-slide {
    padding-right: 0.75rem;
  }

  .job-banner-link {
    &:hover {
      opacity: 0.7;
    }
  }

  .job-banner-img {
    width: 100%;
  }

  .slick-dots {
    .slick-active {
      button {
        &::before {
          color: ${props => props.theme.members.colors.lightGreen};
        }
      }
    }
  }
`

export const StyledJobOffersContainer: React.FC<JobOffersContainerProps> = (props: JobOffersContainerProps) => {
  const loggedOut = props.loggedOut

  const settings = {
    adaptiveHeight: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: 'ease',
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  }

  const JobBannerCta = () => {
    return (
      <JobBannerCtaStyle>
        <p>いますぐ会員登録して、<br/>
          <MemberTechCompanyName />で仕事を見つけよう。
          <a href={signup_user_path()}>無料会員登録</a>
        </p>
        <img alt="無料会員登録" src={ctaBackgroundImage}/>
      </JobBannerCtaStyle>
    )
  }

  const JobOffersBanners = () => {
    return (
      <>
        { loggedOut && <JobBannerCta /> }
        <JobOffersBannersStyle>
          <Slider {...settings}>
            <a className="job-banner-link" href={referral_path()}>
              <img className="lozad job-banner-img" alt="ご友人紹介特典" src={friendSmallImage} />
            </a>
            <a className="job-banner-link" href={job_offers_remotes_path()}>
              <img className="lozad job-banner-img" alt="リモートワーク特集" src={remoteImage} />
            </a>
            <a className="job-banner-link" href={knowledge_path()}>
              <img className="lozad job-banner-img" alt="フリーランスの基礎知識" src={bnrKisoImage} />
            </a>
            <a className="job-banner-link" href='https://dx-pro.net/boost_freelance/'>
              <img className="lozad job-banner-img" alt="DX領域特化型フリーランスエージェント" src={dxBoostImage} />
            </a>
          </Slider>
        </JobOffersBannersStyle>
      </>
    )
  }

  return (
    <JobOffersContainerStyle theme={appTheme}>
      { props.jobOffers.map((jobOffer, index) => {
        return (
          <JobOffersContainerRowStyle key={index}>
            <JobOfferCard jobOffer={jobOffer.detail} isFavorite={jobOffer.isFavorite} isApplied={jobOffer.isApplied} />
            {/* NOTE: お仕事が10件のときにバナーを表示する */}
            { index === 9 && <JobOffersBanners /> }
          </JobOffersContainerRowStyle>
        )
      })}
    </JobOffersContainerStyle>
  )
}
